import { getMessages } from '../../../../../../store/constants';

export const ASIDE_PANEL_ACTIONS_MINIMIZE = getMessages().getText('aside_panel.actions.minimize');
export const ASIDE_PANEL_ACTIONS_EXPAND = getMessages().getText('aside_panel.actions.expand');
